/**
 * Las columnas del reporte de Móviles Inmovilizados, para <GridColumnSelector />.
 *
 * VEC-3696 fase 3: mostrar/ocultar columnas, con lo elegido persistido por usuario.
 *
 * Vive en su propio módulo porque lo consumen la grilla (que arma el hook), el thead y la fila:
 * las tres tienen que hablar de las MISMAS columnas o el header y las celdas se desfasan.
 *
 * *** EL ORDEN DE ESTA LISTA ES EL ORDEN DE LAS COLUMNAS. *** El thead y la fila la recorren,
 * así que agregar una acá la agrega en los dos lados a la vez; es lo que evita el desfasaje.
 */

export const MOVILES_INMOVILIZADOS_COLUMNAS_STORAGE_KEY = 'MovilesInmovilizadosGrid_columnas';

/**
 * `region` es FIJA y no se puede ocultar: es la celda que lleva el chevron que despliega el
 * detalle de la base. Ocultarla dejaría el detalle sin forma de abrirse.
 *
 * Si alguna vez se quiere poder ocultarla, el camino es sacar el chevron a una columna propia
 * —sin título y fija, como la de acciones en las otras grillas—, no permitir ocultar ésta.
 */
export const buildMovilesInmovilizadosColumns = () => [
	{
		name: 'region',
		messageId: 'moviles_inmovilizados.grid.column.region',
		label: 'Región',
		fixed: true,
	},
	{
		name: 'base',
		messageId: 'moviles_inmovilizados.grid.column.base',
		label: 'Base',
	},
	{
		name: 'gerenciador',
		messageId: 'moviles_inmovilizados.grid.column.gerenciador',
		label: 'Gerenciador',
	},
	{
		name: 'total',
		messageId: 'moviles_inmovilizados.grid.column.q_vehiculos_operativos',
		label: 'Q Vehículos OPERATIVOS',
	},
	{
		name: 'inmovilizados',
		messageId: 'moviles_inmovilizados.grid.column.q_paralizadas',
		label: 'Q Paralizadas',
	},
	{
		name: 'porcentajeParalizadas',
		messageId: 'moviles_inmovilizados.grid.column.porcentaje_paralizadas',
		label: '% Paralizadas',
	},
];

export default buildMovilesInmovilizadosColumns;
